import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import CompaniesPage from "./pages/CompaniesPage";
import CaptionLibrariesPage from "./pages/CaptionLibrariesPage";
import PublicCaptionLibraryPage from "./pages/PublicCaptionLibraryPage";
import MarketplacePage from "./pages/MarketplacePage";
import JournalEditorPage from "./pages/JournalEditorPage";
import JournalPlayerPage from "./pages/JournalPlayerPage";
import PublicSlideshowPage from "./pages/PublicSlideshowPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/share/:shareId" element={<PublicSlideshowPage />} />
          <Route path="/share/library/:shareId" element={<PublicCaptionLibraryPage />} />
          <Route path="/explore" element={<MarketplacePage />} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/companies" element={<ProtectedRoute><CompaniesPage /></ProtectedRoute>} />
          <Route path="/caption-libraries" element={<ProtectedRoute><CaptionLibrariesPage /></ProtectedRoute>} />
          <Route path="/journals/:id/edit" element={<ProtectedRoute><JournalEditorPage /></ProtectedRoute>} />
          <Route path="/journals/:id/play" element={<ProtectedRoute><JournalPlayerPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
